import { NavigationSubItem } from "../navigation-item"

export class DesignSystemSubItem extends NavigationSubItem {
  readonly id = "design-system"
  readonly label = "Design System"
  readonly href = "/design/design-system"
  readonly iconName = "design-system-icon"
  readonly isExternal = false
  readonly tabs = []
}
